import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import styles from './MuseumHomeHero.module.scss'

const HERO_TITLE = 'Where legends live forever'

export const MuseumHomeHero: FC = () => {
  const { t } = useTranslation('featured_banner')
  const heroRailLabels = [
    t('rail_label_sports_technology'),
    t('rail_label_digital_assets'),
    t('rail_label_official_marketplace'),
  ]

  return (
    <section className={ styles.museumHomeHero }>
      <div className={ styles.museumHomeHero__frame }>
        <div
          className={ `${styles.museumHomeHero__rail} ${styles.museumHomeHero__rail_left}` }
          aria-hidden={ true }
        >
          { heroRailLabels.map((label) => (
            <span
              key={ `left-${label}` }
              className={ styles.museumHomeHero__railLabel }
            >
              { label }
            </span>
          )) }
        </div>

        <div className={ styles.museumHomeHero__content }>
          <div className={ styles.museumHomeHero__copy }>
            <h1 className={ styles.museumHomeHero__title }>
              { HERO_TITLE }
            </h1>

            <p className={ styles.museumHomeHero__subtitle }>
              { t('subtitle') }
            </p>

            <p className={ styles.museumHomeHero__description }>
              { t('description') }
            </p>

            <a
              className={ styles.museumHomeHero__cta }
              href="#featured-organizers"
            >
              <span>{ t('featured_banner_cta') }</span>
              <FontAwesomeIcon icon={ faArrowRight } />
            </a>
          </div>

          <div className={ styles.museumHomeHero__visual }>
            <div className={ styles.museumHomeHero__glow } aria-hidden={ true } />
            <img
              className={ styles.museumHomeHero__image }
              src="/img/museum/home/hero-trophy.jpg"
              alt="Legend digital trophy"
              width={ 600 }
              height={ 600 }
            />
          </div>
        </div>

        <div
          className={ `${styles.museumHomeHero__rail} ${styles.museumHomeHero__rail_right}` }
          aria-hidden={ true }
        >
          { [...heroRailLabels].reverse().map((label) => (
            <span
              key={ `right-${label}` }
              className={ styles.museumHomeHero__railLabel }
            >
              { label }
            </span>
          )) }
        </div>
      </div>
    </section>
  )
}
